import { MailOutlined } from '@ant-design/icons'
import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { ModalComponent } from 'app/containers/DentalTreatmentManagement/ProfilePatientRecord/layouts/TreatmentSchedule/components'
import { useTranslation } from 'react-i18next'

export const SendTreatmentReceiptEmailModal = () => {
  const { t } = useTranslation()

  return (
    <ModalComponent
      iconOpenModal={
        <BaseCol>
          <MailOutlined rev={undefined} />
        </BaseCol>
      }
      titleOpenModal={t(R.strings.send_treatment_receipt_email)}
      titleModal={t(R.strings.send_treatment_receipt_email)}
      renderContent={
        <BaseSpace>
          <BaseText children={t(R.strings.send_treatment_receipt_email)} />
        </BaseSpace>
      }
    />
  )
}
